import { FixedSizeList } from "react-window";
import UtilsUnit from "../../../utils/UtilsUnit";

const WidgetFixedSizeList = ({ height, width = "100%", itemCount, itemSize, overscanCount = 5, direction = "rtl", children, style = {}, listRef }) => {
  const convertIfNeeded = (value) => {
    if (typeof value === "string" && value.trim().endsWith("%")) {
      return value;
    }
    return UtilsUnit.remToPx(value);
  };

  return (
    <FixedSizeList
      ref={listRef}
      height={convertIfNeeded(height)}
      width={convertIfNeeded(width)}
      itemCount={itemCount}
      itemSize={convertIfNeeded(itemSize)}
      overscanCount={overscanCount}
      direction={direction}
      style={{
        direction: "rtl",
        ...style,
      }}
    >
      {children}
    </FixedSizeList>
  );
};

export default WidgetFixedSizeList;
